




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import SendProductPaymentRequestMessage from '@communications/components/forms/product-payment-request/send-product-payment-request-message.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';

import { SendProductPaymentRequestMessageFormModel } from '@tools/interfaces/template';

@Component({
  name: 'send-product-payment-request-modal',
  components: {
    SendProductPaymentRequestMessage,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class SendProductPaymentRequestModal extends Vue {
  declare $refs: {
    sendProductPaymentRequestMessage: InstanceType<typeof SendProductPaymentRequestMessage> & {
      formModel: SendProductPaymentRequestMessageFormModel;
    };
  };

  @Prop({ type: Boolean, default: false }) readonly showModal!: boolean;
  @Prop({ type: String, default: 'modal-send-payment-request' }) readonly modalId!: string;
  @Prop({ type: String, default: 'subscription' }) readonly entityName!: string;
  @Prop({ type: Array, default: () => [] }) readonly contactIds!: number[];
  @Prop({ type: Array, default: () => [] }) readonly selectedItemIds!: number[];

  isProcessing = false;
  requestSent = false;
  successItems: any[] = [];
  errorItems: any[] = [];

  errorPage = 1;
  errorPerPage = 5;
  errors: Record<string, string[]> = {};

  get modalTitle(): string {
    return this.$t('global.modals.send_product_payment_request_message.title').toString();
  }

  get defaultTemplateId(): number | null {
    const settings = this.$store.getters['centerSettings/centerSettings'];
    if (this.entityName === 'subscription') {
      return settings?.subscription_payment_request_email_template_id;
    }
    if (this.entityName === 'enrollment') {
      return settings?.enrollment_payment_request_email_template_id;
    }
    return null;
  }

  get paginatedErrorItems() {
    const start = (this.errorPage - 1) * this.errorPerPage;
    return this.errorItems.slice(start, start + this.errorPerPage);
  }

  closeModal() {
    this.$emit('close');
    this.reset();
  }

  reset() {
    this.isProcessing = false;
    this.requestSent = false;
    this.successItems = [];
    this.errorItems = [];
    this.errorPage = 1;
  }

  process() {
    this.isProcessing = true;

    const path = this.$bpcApiRouteHelper.getEntityPath('messages');
    const payload = this.$refs.sendProductPaymentRequestMessage.formModel;

    this.$bpcApi.post(`${path}/bulk-send-product-payment-request`, payload).subscribe(
      response => {
        this.isProcessing = false;
        const data = response.data || [];
        const errors = (response as any).errors || [];

        this.successItems = data;
        this.errorItems = errors.map((item: any) => ({
          id: item.entity_id,
          code: item.entity_code,
          name: item.entity_name,
          reason: item.error,
        }));
        this.requestSent = true;
      },
      error => {
        this.isProcessing = false;
        this.errors = error?.response?.data?.errors || {};
        this.requestSent = false;
      },
    );
  }
}
